import {getId} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {CodiSubHeader} from 'views/Document/components/Codi/CodiSiderHeading'
import CodiContext from './CodiContext'
import _ from "lodash";
import {Link} from "react-router-dom";
import {paths} from "../../MainPage/contains";
import {GiIronCross} from "react-icons/gi";
import {renderIf} from "../../Shared";
import {useFeedback} from "../Feedback/functions/useFeedback";
import {PiWarningDuotone} from "react-icons/pi";

const getPathDocumentType = (documentType) => {
    const documentTypePath = _.get(documentType, 'title')
    if (!!_.get(documentType, 'parent')) {
        return [
            getPathDocumentType(_.get(documentType, 'parent')),
            documentTypePath,
        ].join(' - ')
    }
    return documentTypePath
}

const CodiInfo = () => {
    const t = useTranslate()

    const {item, rows} = useContext(CodiContext)

    const [root, indexes] = useMemo(() => {
        const _root = Array.from(rows ?? [])[0]
        return [_root, Array.from(_root?.children_rows ?? [])]
    }, [rows])

    const {reportModal, handleReport} = useFeedback({
        notifyListeners: {}
    })

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
                <CodiSubHeader title="basic info"/>
                {renderIf(
                    item?.document_type,
                    <div className="flex items-start gap-1 text-sm italic">
                        <span className="text-color-400">{`${t('type book')} : `}</span>
                        <span className="flex-1 font-semibold text-color-000">
                {getPathDocumentType(item?.document_type)}
              </span>
                    </div>
                )}
                {renderIf(
                    item.document_no,
                    <div className="flex items-start gap-1 text-sm italic">
                        <span className="text-color-400">{`${t('acronym')} : `}</span>
                        <span className="flex-1 font-semibold text-color-000">{item.document_no}</span>
                    </div>
                )}
                {renderIf(
                    indexes.length,
                    <div className="flex items-start gap-1 text-sm italic">
                        <span className="text-color-400">{`${t('total')} : `}</span>
                        <span className="flex-1 font-semibold text-color-000">
                          {`${indexes.filter((e) => e.index_typecd === 'chapter').length} ${_.lowerCase(t('chapter'))}`}
                        </span>
                    </div>
                )}
                {renderIf(
                    item?.language,
                    <div className="flex items-start gap-1 text-sm italic">
                        <span className="text-color-400">{`${t('language')} : `}</span>
                        <span className="flex-1 font-semibold text-color-000">
                {t(item?.language)}
              </span>
                    </div>
                )}
                {renderIf(
                    !!item?.version,
                    <div className="flex items-start gap-1 text-sm italic">
                        <span className="text-color-400">{`${t('version')} : `}</span>
                        <span className="flex-1 font-semibold text-color-000">
                {item?.version}
              </span>
                    </div>
                )}
                {_.get(item, 'categories', []).length > 0 && (
                    <div className="flex flex-col gap-1 text-sm italic">
                        <span className="text-color-400">{`${t('categories')} : `}</span>
                        <div className="flex flex-wrap flex-1 gap-1 md:gap-3 ml-2">
                            {(_.get(item, 'categories')).map((e, index) => (
                                <div
                                    key={index}
                                    className="flex items-center text-primary">
                                    <GiIronCross size={8} className="mr-1"/>
                                    <Link
                                        to={
                                            paths.categoryPath
                                                .replace(':category', e.id)
                                        }
                                        key={e.id}
                                        className="italic font-medium text-sm">
                                        {e.name}
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>
            {/*<div className="space-y-2">*/}
            {/*  <CodiSubHeader title="error report" />*/}
            {/*  <AdvancedActionGroups.SimpleActionWrapper*/}
            {/*    title="report to admin"*/}
            {/*    description="report to admin description">*/}
            {/*    <CodiReportButton id={getId(item)} />*/}
            {/*  </AdvancedActionGroups.SimpleActionWrapper>*/}
            {/*</div>*/}

            <div className="flex flex-col gap-2 mt-6">
                <CodiSubHeader title="report to admin"/>
                <div className="flex flex-col">
                    <div
                        onClick={() => {
                            handleReport({
                                ref_type: 'codi_document',
                                ref_id: getId(item),
                                feedback_category_id: 'bible-information'
                            })
                        }}
                        className="flex items-center flex-1 gap-2 text-orange-300 hover:text-orange-500 cursor-pointer">
                        <PiWarningDuotone size={15} className="text-orange-500"/>
                        <span className="font-medium text-sm italic">{t('feedback')}</span>
                    </div>
                    <span className="text-xs text-color-500 italic leading-snug">
            {`* ${t('send update bible description')}`}
          </span>
                </div>
            </div>
            {reportModal}
        </div>
    )
}

export default CodiInfo
